export const PREPARE_IMPORT_CUSTOMERS_MODAL_OPEN = 'PREPARE_IMPORT_CUSTOMERS_MODAL_OPEN';
export const prepareToOpenImportCustomersModal = () => {
  return {
    type: PREPARE_IMPORT_CUSTOMERS_MODAL_OPEN,
  };
};

export const INITIATE_CUSTOMERS_CSV_IMPORT = 'INITIATE_CUSTOMERS_CSV_IMPORT';
export const startImport = (ignoreCsvRecord, file) => {
  return {
    type: INITIATE_CUSTOMERS_CSV_IMPORT,
    ignoreCsvRecord,
    file,
  };
};

export const CUSTOMERS_CSV_IMPORT_SUCCESS = 'CUSTOMERS_CSV_IMPORT_SUCCESS';
export const importSuccess = (batchId) => {
  return {
    type: CUSTOMERS_CSV_IMPORT_SUCCESS,
    batchId,
  };
};

export const CUSTOMERS_IMPORT_FAILURE = 'CUSTOMERS_IMPORT_FAILURE';
export const customerImportFailure = (error) => ({
  type: CUSTOMERS_IMPORT_FAILURE,
  error,
});
